import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnDestroy {

  @Input()
  public closable: boolean = true;

  @Input()
  public title: string = null;

  @Input()
  public message: string = null;

  @Input()
  public class: string = null;

  @Input()
  public buttons: MessageBoxButton[] = [];

  @Output() close: EventEmitter<any> = new EventEmitter<any>();  

  constructor(private modal: ModalService) { }

  click(button: MessageBoxButton) {

    if (button.click) {

      let event: MessageBoxEvent = { button: button, preventDefault: false };
      button.click(event);

      if (!event.preventDefault) {
        this.modal.of(this).hide();
      }
    }
    else {
      this.modal.of(this).hide();
    }
  }

  ngOnDestroy() {
    this.close.emit();
  }
}

export interface MessageBoxButton {
  name?: string;
  icon?: string;
  class?: string;
  click?(event: MessageBoxEvent): void;
}

export interface MessageBoxEvent {
  button: MessageBoxButton;
  preventDefault: boolean;
}
